import { useContext } from 'react';
import { AppFilterProps, ReactChildren, SelectOptions, ValuesOfAny } from '../interfaces/Common';
import { AuthContext } from '../Helpers/Contexts/authContext';
import { Navigate, useLocation } from 'react-router-dom';
import routes from './routes';
import { getFileUrl } from './apiService';
import moment from 'moment';
import { enqueueSnackbar } from 'notistack';
import KenLoader from '../GlobalComponents/KenLoader';
import storage from '../storageService';
import { Country, State, City } from 'country-state-city';
import { KEY_ACCESS_TOKEN, KEY_REFRESH_TOKEN } from '../Helpers/constant';

export const getCombinedString: (array: Array<string>, seperator?: string) => string = (array: Array<string>, seperator?: string) => {
  let arrayString: string = '';
  let customSeperator = seperator ? seperator : ',';
  array.forEach((items: string, index: number) => {
    if (arrayString === '') {
      arrayString = `${items}${customSeperator} `;
    } else if (index === array.length - 1) {
      arrayString = arrayString + `${items}`;
    } else {
      arrayString = arrayString + `${items}${customSeperator} `;
    }
  });
  return arrayString;
};

export const splitCombinedStringintoArray = (value: string, seperator?: string) => {
  let customSeperator = seperator ? seperator : ',';
  return value.split(customSeperator);
};

export const handleFilterData: (key: string, array: Array<any>) => Array<SelectOptions> = (key: string, array: Array<any>) => {
  const set = new Set();
  const handleNull = (data: string) => {
    if (data && data !== null) {
      set.add(data);
    }
  };
  for (let i = 0; i < array?.length; i++) {
    if (array[i]) {
      const category = array[i][key] as string;
      if (category && `${category}`.includes(';')) {
        const categoryArray = category?.split(';');
        for (let j = 0; j < categoryArray.length; j++) {
          handleNull(categoryArray[j]);
        }
      } else {
        handleNull(category);
      }
    }
  }
  return [...set].map((items) => {
    return { label: items, value: items };
  }) as Array<SelectOptions>;
};

export const getYears: (start: number) => Array<SelectOptions> = (start: number) => {
  const array: Array<SelectOptions> = [];
  const date = new Date();
  for (let i = start; i <= date.getFullYear(); i++) {
    array.push({
      label: `${i}`,
      value: `${i}`,
    });
  }
  return array.reverse();
};

export const checkAuthenticationStatus = async () => {
  try {
    const user = await storage.get('user');
    const accessToken = await storage.get(KEY_ACCESS_TOKEN);
    const refreshToken = await storage.get(KEY_REFRESH_TOKEN);
    
    if (user && accessToken && refreshToken) {
      const parsedUser = JSON.parse(user);
      return {
        isAuthenticated: true,
        user: parsedUser,
        hasValidTokens: !!(parsedUser.accessToken?.token && parsedUser.refreshToken?.token)
      };
    }
    return {
      isAuthenticated: false,
      user: null,
      hasValidTokens: false
    };
  } catch (error) {
    console.error('Error checking authentication status:', error);
    return {
      isAuthenticated: false,
      user: null,
      hasValidTokens: false
    };
  }
};

export const PublicRoute: React.FunctionComponent<ReactChildren> = ({ children }) => {
  const {
    state: { isAuthenticated, isLoading },
  } = useContext(AuthContext);
console.log(isAuthenticated, 'isAuthenticated');

  // Show loading while authentication state is being restored
  if (isLoading) {
    return <KenLoader />;
  }

  if (isAuthenticated) {
    return <Navigate to={routes.home} />;
  }
  return children;
};

export const PrivateRoute: React.FunctionComponent<ReactChildren> = ({ children }) => {
  const {
    state: { isAuthenticated, user, isLoading },
    dispatch,
  }: any = useContext(AuthContext);
  const status = user?.status;
  const { pathname } = useLocation();
  console.log(pathname, "pathnamepathnamepathname");

  // Show loading while authentication state is being restored
  if (isLoading) {
    return <KenLoader />;
  }

  // Allow both /flame-signup and /privacy-policy
  const isSignupCurrent = pathname === '/home' || pathname === '/privacy-policy';
  const isLogin = pathname === '/login';

  // Check if user is not authenticated
  if (!isAuthenticated) {
    return <Navigate to={routes.landingpage} />;
  }

  // Need to change this 
  if (!status?.isActive && status?.isSignupCompleted && !isLogin) {
    enqueueSnackbar('User not found', { variant: 'error' });
    dispatch({
      type: 'LOGOUT',
      payload: {
        user: {},
        token: null,
      },
    });
    return <Navigate to={routes.landingpage} />;
  }

  //---------


  if (!isAuthenticated) {
    return <Navigate to={routes.landingpage} />;
  }


  // Need to change this for development

  // if (!status?.isSignupCompleted && !isSignupCurrent) {
  //   if (pathname === '/privacy-policy') {
  //     return <Navigate to={routes.privacyPolicy} />;
  //   }
  //   else {
  //     return <Navigate to={routes.home} />;
  //   }
  // }

  //---------

console.log(status, 'status' );

  if ((!status?.isProfileVerified || status?.isProfileVerified !== 'Approved') && status?.isSignupCompleted) {
    dispatch({
      type: 'LOGOUT',
      payload: {
        user: {},
        token: null,
      },
    });
    return <Navigate to={`..${routes.landingpage}?msg=requestsuccess`} replace={true} />;
  }

  return children;
};


export const AppFilterFunction: (props: AppFilterProps) => Array<any> = (props) => {
  const { filterData, data } = props;
  if (Object.keys(filterData).length === 0) {
    return data;
  }

  const filteringData = { ...filterData };
  let sampleEventData = [...data];
  for (const i in filteringData) {
    const filteredArray = [];
    for (let j = 0; j < sampleEventData.length; j++) {
      const element = sampleEventData[j];
      if (element[i] !== null) {
        if (`${element[i]}`.toLowerCase().includes(`${filteringData[i]}`.toLowerCase())) {
          filteredArray.push(element);
        }
      }
    }
    sampleEventData = [...filteredArray];
  }
  return sampleEventData;
};

export function pad(n: string, width: number, z?: string) {
  z = z || '0';
  n = n + '';
  return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}

export const handleFiles = async (e: React.ChangeEvent<HTMLInputElement>, files: any, types?: Array<string>, size?: number) => {
  // File Check
  if (!e.target.files) {
    return { message: 'Please Upload File', success: false };
  }
  const getFile = e.target.files[0];
  const customSize = size ? size : 2000000;

  // File Type Check
  if (types) {
    const getMatch: Array<string> = types?.filter((items) => {
      return items === getFile.type;
    });
    if (getMatch.length === 0) {
      return {
        message: `Only the ${types.map((items) => {
          return `${items} `;
        })} formats are accepted`,
        success: false,
      };
    }
  }

  // File Size Check
  if (getFile.size > customSize) {
    return { message: 'File is larger than 1MB', success: false };
  }

  return await toBase64(e.target.files[0]);
};

export const moneyValidator = (start: string, end: string) => {
  const salary = start === end;
  return salary ? `${start} LPA` : `${start}-${end} LPA`;
};

export const rangeValidatorPayload = (year: string) => {
  const getYears = year.split('-');
  if (getYears.length === 2) {
    return [parseInt(getYears[0]), parseInt(getYears[1])];
  } else if (getYears.length === 1) {
    return [parseInt(getYears[0]), parseInt(getYears[0])];
  } else {
    return '';
  }
};

export const uniqueArrayCreator = (array: Array<any>, key: string) => {
  return Array.from(
    new Set([
      ...array?.map((items: any) => {
        return items[key];
      }),
    ])
  );
};

export const registeredDatas = (array: Array<any>, objectKey: string) => {
  const newObject: ValuesOfAny = {};
  array?.forEach((items: any) => {
    const keyValue = items[objectKey];
    const date = moment(keyValue).format('Do MMMM YYYY');
    items['find'] = date;
    if (newObject.hasOwnProperty(date)) {
      newObject[date].push({ ...items });
    } else {
      newObject[`${date}`] = [items];
    }
  });
  return newObject;
};

export const copyFunction = (text: string) => {
  const clipboardItem = new ClipboardItem({ 'text/plain': new Blob([text], { type: 'text/plain' }) });
  navigator.clipboard
    .write([clipboardItem])
    .then(() => {
      enqueueSnackbar({ message: 'Link copied', variant: 'success', autoHideDuration: 1000 });
    })
    .catch((err) => {
      console.error(err);
    });
};

export const removeHTMLTags = (htmlString: string) => {
  return htmlString.replace(/<[^>]*>/g, '');
};

export const toBase64: (file: any) => Promise<unknown> = (file: any) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
  });

export function removeNullKeys(obj: any) {
  for (let key in obj) {
    if (obj[key] === null) {
      delete obj[key];
    } else if (typeof obj[key] === 'object') {
      removeNullKeys(obj[key]);
      if (Object.keys(obj[key]).length === 0) {
        delete obj[key];
      }
    }
  }
  return obj;
}
export const splitBase64 = (base64: string) => {
  const splitData = base64.split(',');
  return splitData[1];
};

const createImage = (src: string): Promise<HTMLImageElement> =>
  new Promise((resolve, reject) => {
    const image = new Image();

    if (!src.startsWith('data:')) {
      image.crossOrigin = 'anonymous';
    }

    image.onload = () => resolve(image);

    image.onerror = (e) => {
      console.error(`Image failed to load: ${src}`);
      reject(new Error(`Failed to load image: ${src}`));
    };

    image.src = src;
  });

export const getCroppedImg = async (
  imageSrc: string,
  croppedAreaPixels: { width: number; height: number; x: number; y: number },
  imageType: string = 'imag/png',
  outputType: 'base64' | 'url' = 'base64'
): Promise<string> => {
  const image = await createImage(imageSrc);
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  if (!ctx) throw new Error('No 2D context');

  canvas.width = croppedAreaPixels.width;
  canvas.height = croppedAreaPixels.height;

  ctx.drawImage(image, croppedAreaPixels.x, croppedAreaPixels.y, croppedAreaPixels.width, croppedAreaPixels.height, 0, 0, croppedAreaPixels.width, croppedAreaPixels.height);

  if (outputType === 'url') {
    return new Promise((resolve) => {
      canvas.toBlob((blob) => {
        if (!blob) throw new Error('Canvas is empty');
        const blobUrl = URL.createObjectURL(blob);
        resolve(blobUrl);
      }, imageType);
    });
  }

  // Default to base64
  return canvas.toDataURL(imageType);
};
export const getCountries = () => {
  return Country.getAllCountries().map((country) => ({
    label: country.name,
    value: country.isoCode,
    ...country,
  }));
};

export const getStates = (countryCode: string) => {
  return State.getStatesOfCountry(countryCode).map((state) => ({
    label: state.name,
    value: state.isoCode,
    ...state,
  }));
};

export const getCities = (countryCode: string, stateCode: string) => {
  return City.getCitiesOfState(countryCode, stateCode).map((city) => ({
    label: city.name,
    value: city.name,
    ...city,
  }));
};

export const generateYear = (limit: number = 2000) => {
  const endYear = moment().year();
  const yearList = [];
  for (let year = limit; year <= endYear; year++) {
    yearList.push(year);
  }

  return yearList;
};
